const hapticFeedback = {
  trigger: () => {},
};

export default hapticFeedback;
